import React from 'react'
import Image from "./Image"

export default function DefaultSourceImage({source, defaultSource, ...props}) {
	return <Image source={source || defaultSource} {...props}/>
}